
import { cn } from "@/lib/utils";
import { Button as ShadcnButton } from "@/components/ui/button";
import { ButtonProps as ShadcnButtonProps } from "@/components/ui/button";
import { forwardRef } from "react";

interface ButtonProps extends ShadcnButtonProps {
  isAnimated?: boolean;
  isGlass?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, isAnimated, isGlass, variant, children, ...props }, ref) => {
    return (
      <ShadcnButton
        ref={ref}
        className={cn(
          // Base styles
          "font-medium transition-all duration-300",
          
          // Shadow and hover effects
          "shadow-subtle hover:shadow-elevation",
          
          // Animation styles
          isAnimated && "transform hover:-translate-y-0.5 active:translate-y-0 active:shadow-subtle",
          
          // Glass morphism
          isGlass && "bg-white/90 backdrop-blur-sm border border-white/40",
          
          // Custom class
          className
        )}
        variant={isGlass ? "ghost" : variant}
        {...props}
      >
        {children}
      </ShadcnButton>
    );
  }
);

Button.displayName = "Button";
